import { render } from "./CompanyEditPage.vue?vue&type=template&id=5b1770c4&scoped=true"
import script from "./CompanyEditPage.vue?vue&type=script&lang=js"
export * from "./CompanyEditPage.vue?vue&type=script&lang=js"

import "./CompanyEditPage.vue?vue&type=style&index=0&id=5b1770c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1770c4"]])

export default __exports__